import {Mapper} from '@s-ui/domain'

/**
 * @implements Mapper
 */
export class TrackingPublishYourCarWithPlateResultsMapper extends Mapper {
  /**
   * @constructor
   * @param {Object} param
   * @param {Object} param.fromPageTrackingJsonToTrackingDataValueObjectMapper
   */
  constructor({config, fromPageTrackingJsonToTrackingDataValueObjectMapper}) {
    super()

    this._fromPageTrackingJsonToTrackingDataValueObjectMapper = fromPageTrackingJsonToTrackingDataValueObjectMapper
  }

  /**
   * @param {Object} param
   * @param {String} param.page
   * @param {String} param.culture
   */
  map({page, culture, data}) {
    return this._fromPageTrackingJsonToTrackingDataValueObjectMapper
      .setParams({
        page,
        culture
      })
      .map()
  }
}
